<div class="notifications">
  <div class="header">
    <div class="header-text">
      {{ 'notifications.dialog.title' | translate }}
    </div>
    <div class="actions">
      <pp-tooltip
        class="tooltip"
        size="small"
        customContent
        [text]="'notifications.dialog.readAllTooltip' | translate">
        @let canReadAll = hasUnread() && !readAllInProgress();
        <button
          class="read-all"
          [class.has-unread]="canReadAll"
          type="button"
          puButton
          uiType="quaternary"
          size="s"
          [onlyIcon]="true"
          (click)="canReadAll && markAllAsRead()">
          <pu-icon iconName="read-all" size="20" />
        </button>
      </pp-tooltip>
      <button
        class="close"
        type="button"
        puButton
        uiType="quaternary"
        size="s"
        [onlyIcon]="true"
        (click)="close()">
        <pu-icon iconName="close" size="20" />
      </button>
    </div>
  </div>

  <div class="body">
    @if (initTabs()) {
      <mat-slide-toggle
        (change)="toggleNotifications($event)"
        [checked]="enableNotifications()"
        class="offset-bottom">
        {{ 'notifications.dialog.showNotifications.toggle' | translate }}
      </mat-slide-toggle>
    }
    <section class="section">
      @if (initTabs()) {
        <pp-tabs class="tabs" [tabs]="tabs" (index)="setTab($event)" />
      }

      <div class="tabs-content">
        @switch (tab) {
          @case ('messages') {
            <pp-notifications-list
              [messages]="messages()"
              [loading]="messagesLoading()"
              (loadMore)="loadMoreMessages()"
              (markAsRead)="markAsRead($event)" />
          }
          @case ('threeDS') {
            <pp-notifications-list
              [messages]="threeDs()"
              [type]="notificationTypeEnum.THREE_DS_NOTIFICATION"
              [loading]="threeDsLoading()"
              (loadMore)="loadMoreThreeDs()"
              (markAsRead)="markAsReadThreeDs($event)" />
          }
        }
      </div>
    </section>
  </div>
</div>
